<template>
	<v-tooltip
		class="ao-tooltip ao-top"
		:text="hint"
		location="bottom"
	>
		<template v-slot:activator="{ props }">
			<div
				v-bind="props"
				class="ao-tooltip-activator ao-p4-medium"
			>
				<slot>
					{{ title }}
				</slot>
			</div>
		</template>
	</v-tooltip>
</template>

<script>
export default {
	name: 'AoTooltip',
	props: {
		title: String,
		hint: String,
	},
}
</script>

<style lang="scss">
.ao-tooltip.v-tooltip {
	.v-overlay__content {
		background: #0d1722 !important;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
		border-radius: 4px;

		padding: 4px 8px;
		margin-top: -10px;
		margin-bottom: 10px;

		font-family: Inter, sans-serif;
		font-weight: 500;
		font-size: 10px;
		line-height: 14px;

		&:after {
			content: '';
			position: absolute;
			top: 100%;
			left: 50%;
			height: 8px;
			width: 8px;
			background: inherit;
			transform: translate(-50%, -50%) rotate(45deg);
		}
	}
}

.ao-tooltip-activator {
	width: 100%;
	cursor: pointer;
}

.ao-tooltip.ao-left.v-tooltip {
	.v-overlay__content {
		&:after {
			top: 50%;
			left: 0;
		}
	}
}

.ao-tooltip.ao-right.v-tooltip {
	.v-overlay__content {
		&:after {
			top: 50%;
			right: 0;
		}
	}
}

.ao-tooltip.ao-top.v-tooltip {
	.v-overlay__content {
		&:after {
			top: 0;
			left: 50%;
		}
	}
}

.ao-tooltip.ao-bottom.v-tooltip {
	.v-overlay__content {
		&:after {
			bottom: 0;
			left: 50%;
		}
	}
}
</style>
